import React from "react";
import { Card } from "primereact/card";
import { Image } from "primereact/image";
import pic1 from "./widgets/CopyViewWidget1.jpg";
import pic2 from "./widgets/CopyViewWidget2.jpg";

export default function CopyViewWidgetPic() {
  return (
    <div className="grid widget-section">
      <div className="col-12 md:col-6">
        <Card className="shadow-3 widget-card">
          <Image
            src={pic1}
            alt="Copy View Widget 1"
            preview
          />
        </Card>
      </div>

      <div className="col-12 md:col-6">
        <Card className="shadow-3 widget-card">
          <Image
            src={pic2}
            alt="Copy View Widget 2"
            preview
          />
        </Card>
      </div>
    </div>
  );
}
